export default "__VITE_ASSET__CLkCeKZD__"